module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-right-item"
  }, [_vm._t("right-toolbar-before"), _vm._v(" "), (_vm.toolbars.navigation) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.s_navigation),
      expression: "!s_navigation"
    }],
    staticClass: "op-icon fa fa-mavon-bars",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_navigation_on) + " (F8)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('navigation')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.navigation) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_navigation),
      expression: "s_navigation"
    }],
    staticClass: "op-icon fa fa-mavon-bars selected",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_navigation_off) + " (F8)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('navigation')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.preview) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_preview_switch),
      expression: "s_preview_switch"
    }],
    staticClass: "op-icon fa fa-mavon-eye-slash selected",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_edit) + " (F9)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('preview')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.preview) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.s_preview_switch),
      expression: "!s_preview_switch"
    }],
    staticClass: "op-icon fa fa-mavon-eye",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_preview) + " (F9)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('preview')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.fullscreen) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.s_fullScreen),
      expression: "!s_fullScreen"
    }],
    staticClass: "op-icon fa fa-mavon-arrows-alt",
    attrs: {
      "type": "button",
      "title": ((_vm.d_words.tl_fullscreen_on) + " (F10)"),
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('fullscreen')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.fullscreen) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_fullScreen),
      expression: "s_fullScreen"
    }],
    staticClass: "op-icon fa fa-mavon-compress selected",
    attrs: {
      "type": "button",
      "title": ((_vm.d_words.tl_fullscreen_off) + " (F10)"),
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('fullscreen')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.readmodel) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-window-maximize",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.d_words.tl_read) + " (F11)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('read')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.subfield) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-columns",
    class: {
      'selected': _vm.s_subfield
    },
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": ((_vm.s_subfield ? _vm.d_words.tl_single_column : _vm.d_words.tl_double_column) + " (F12)")
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('subfield')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.help && _vm.toolbars.htmlcode && _vm.toolbars.readmodel && _vm.toolbars.fullscreen && _vm.toolbars.subfield && _vm.toolbars.navigation) ? _c('span', {
    staticClass: "op-icon-divider"
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.htmlcode) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.s_html_code),
      expression: "!s_html_code"
    }],
    staticClass: "op-icon fa fa-mavon-code",
    attrs: {
      "type": "button",
      "title": _vm.d_words.tl_html_on,
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('html')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.htmlcode) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.s_html_code),
      expression: "s_html_code"
    }],
    staticClass: "op-icon fa fa-mavon-code selected",
    attrs: {
      "type": "button",
      "title": _vm.d_words.tl_html_off,
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('html')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toolbars.help) ? _c('button', {
    staticClass: "op-icon fa fa-mavon-question-circle",
    staticStyle: {
      "font-size": "17px",
      "padding": "5px 6px 5px 3px"
    },
    attrs: {
      "type": "button",
      "title": _vm.d_words.tl_help,
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$clicks('help')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right-toolbar-after")], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6863cec0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6863cec0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/md-toolbar-right.vue
// module id = 217
// module chunks = 0